export interface Resident {
  id: string;
  slug: string;
  name: string;
  role: 'Owner' | 'Renter' | 'Resident' | 'Multiple Unit Owner';
  tower: 'Tower 1' | 'Tower 2';
  unit: string;
  profession?: string;
  bio?: string;
  servicesOffered?: string[];
  interests?: string[];
  socialLinks?: { platform: string; url: string }[];
  vouchedBy?: string;
  phone?: string;
  email?: string;
  phoneVisible?: boolean;
  emailVisible?: boolean;
  joinedYear?: number;
  purchaseYear?: number;
  avatar?: string;
  isVerified: boolean;
  isSponsor?: boolean;
}

export const mockResidents: Resident[] = [
  {
    id: 'r1',
    slug: 'marcus-chen',
    name: 'Marcus Chen',
    role: 'Owner',
    tower: 'Tower 1',
    unit: '2204',
    profession: 'Architect',
    bio: 'Principal at Chen & Associates Architecture. Moved to Panorama in 2019 for the views and stayed for the community. Happy to chat about interior renovation ideas — I\'ve done two units here.',
    servicesOffered: ['Interior Design Consultation', 'Renovation Planning'],
    interests: ['Architecture', 'Photography', 'Cycling', 'Jazz'],
    socialLinks: [{ platform: 'LinkedIn', url: '#' }],
    vouchedBy: 'Priya Nair',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2019,
    purchaseYear: 2019,
    isVerified: true,
  },
  {
    id: 'r2',
    slug: 'priya-nair',
    name: 'Priya Nair',
    role: 'Owner',
    tower: 'Tower 1',
    unit: '1807',
    profession: 'Cardiologist',
    bio: 'Cardiologist at Desert Springs Hospital. Panorama resident since 2017. I love the building community and try to stay active in the gym.',
    interests: ['Fitness', 'Cooking', 'Travel', 'Yoga'],
    vouchedBy: 'James Whitfield',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2017,
    purchaseYear: 2017,
    isVerified: true,
  },
  {
    id: 'r3',
    slug: 'james-whitfield',
    name: 'James Whitfield',
    role: 'Multiple Unit Owner',
    tower: 'Tower 1',
    unit: '3101, 3102',
    profession: 'Real Estate Developer',
    bio: 'Las Vegas-based developer with a focus on luxury residential. Own two units at Panorama — one primary, one investment. Available for real estate advice.',
    servicesOffered: ['Real Estate Consulting', 'Investment Property Advice'],
    interests: ['Real Estate', 'Golf', 'Wine', 'Architecture'],
    socialLinks: [{ platform: 'LinkedIn', url: '#' }],
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2016,
    purchaseYear: 2016,
    isVerified: true,
  },
  {
    id: 'r4',
    slug: 'sofia-reyes',
    name: 'Sofia Reyes',
    role: 'Renter',
    tower: 'Tower 2',
    unit: '1504',
    profession: 'UX Designer',
    bio: 'Product designer at a tech startup. Renting at Panorama while I figure out if Vegas is home. Love the pool and the Strip views.',
    servicesOffered: ['Logo Design', 'Brand Identity', 'UI/UX Consulting'],
    interests: ['Design', 'Hiking', 'Coffee', 'Podcasts'],
    socialLinks: [{ platform: 'Instagram', url: '#' }, { platform: 'LinkedIn', url: '#' }],
    vouchedBy: 'Marcus Chen',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2023,
    isVerified: true,
  },
  {
    id: 'r5',
    slug: 'derek-okafor',
    name: 'Derek Okafor',
    role: 'Resident',
    tower: 'Tower 2',
    unit: '2208',
    profession: 'Personal Trainer',
    bio: 'Certified personal trainer and nutrition coach. I work out of the building gym and offer sessions to residents. Specializing in strength training and body recomposition.',
    servicesOffered: ['Personal Training', 'Nutrition Coaching', 'Group Fitness'],
    interests: ['Fitness', 'Basketball', 'Nutrition', 'Meditation'],
    vouchedBy: 'Priya Nair',
    emailVisible: true,
    email: 'derek@example.com',
    phoneVisible: false,
    joinedYear: 2022,
    isVerified: true,
  },
  {
    id: 'r6',
    slug: 'claire-fontaine',
    name: 'Claire Fontaine',
    role: 'Owner',
    tower: 'Tower 2',
    unit: '2901',
    profession: 'Interior Designer',
    bio: 'Principal designer at Fontaine Interiors. Specializing in high-rise residential and luxury hospitality. Have designed three units in this building.',
    servicesOffered: ['Interior Design', 'Space Planning', 'Furniture Sourcing'],
    interests: ['Design', 'Art', 'Travel', 'Cooking'],
    socialLinks: [{ platform: 'Instagram', url: '#' }, { platform: 'LinkedIn', url: '#' }],
    vouchedBy: 'James Whitfield',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2020,
    purchaseYear: 2020,
    isVerified: true,
  },
  {
    id: 'r7',
    slug: 'ryan-kowalski',
    name: 'Ryan Kowalski',
    role: 'Renter',
    tower: 'Tower 1',
    unit: '1203',
    profession: 'Software Engineer',
    bio: 'Senior engineer at a fintech company. Remote worker who loves the building amenities. Happy to help with tech questions.',
    interests: ['Tech', 'Gaming', 'Cycling', 'Coffee'],
    vouchedBy: 'Sofia Reyes',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2023,
    isVerified: true,
  },
  {
    id: 'r8',
    slug: 'natasha-volkov',
    name: 'Natasha Volkov',
    role: 'Owner',
    tower: 'Tower 2',
    unit: '3305',
    profession: 'Attorney',
    bio: 'Corporate attorney at a downtown Las Vegas firm. Panorama resident since 2018. Enjoy the community events and the building\'s central location.',
    interests: ['Law', 'Reading', 'Wine', 'Pilates'],
    vouchedBy: 'Priya Nair',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2018,
    purchaseYear: 2018,
    isVerified: true,
  },
  {
    id: 'r9',
    slug: 'leo-santos',
    name: 'Leo Santos',
    role: 'Resident',
    tower: 'Tower 1',
    unit: '908',
    profession: 'Photographer',
    bio: 'Commercial and portrait photographer. Available for headshots, events, and real estate photography. Have done several unit listing shoots in the building.',
    servicesOffered: ['Portrait Photography', 'Real Estate Photography', 'Event Photography'],
    interests: ['Photography', 'Travel', 'Music', 'Film'],
    socialLinks: [{ platform: 'Instagram', url: '#' }],
    vouchedBy: 'Marcus Chen',
    emailVisible: true,
    email: 'leo@example.com',
    phoneVisible: false,
    joinedYear: 2021,
    isVerified: true,
  },
  {
    id: 'r10',
    slug: 'amanda-park',
    name: 'Amanda Park',
    role: 'Renter',
    tower: 'Tower 2',
    unit: '1102',
    profession: 'Nurse Practitioner',
    bio: 'NP at Valley Hospital. Night shift worker — please be mindful of noise in the evenings! Happy to chat about health topics.',
    interests: ['Healthcare', 'Yoga', 'Cooking', 'Dogs'],
    vouchedBy: 'Priya Nair',
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2022,
    isVerified: true,
  },
  {
    id: 'r11',
    slug: 'thomas-berg',
    name: 'Thomas Berg',
    role: 'Multiple Unit Owner',
    tower: 'Tower 2',
    unit: '2401, 2402, 2403',
    profession: 'Investor',
    bio: 'Long-term investor in Panorama. Own three units across Tower 2. Interested in connecting with other owners about building matters.',
    interests: ['Real Estate', 'Finance', 'Tennis', 'Travel'],
    emailVisible: false,
    phoneVisible: false,
    joinedYear: 2015,
    purchaseYear: 2015,
    isVerified: true,
  },
  {
    id: 'r12',
    slug: 'maya-johnson',
    name: 'Maya Johnson',
    role: 'Resident',
    tower: 'Tower 1',
    unit: '1601',
    profession: 'Yoga Instructor',
    bio: 'Certified yoga and meditation instructor. Offer private sessions in-unit or in the amenity spaces. Also available for group classes.',
    servicesOffered: ['Private Yoga Sessions', 'Meditation Coaching', 'Group Yoga'],
    interests: ['Yoga', 'Wellness', 'Nutrition', 'Hiking'],
    socialLinks: [{ platform: 'Instagram', url: '#' }],
    vouchedBy: 'Derek Okafor',
    emailVisible: true,
    email: 'maya@example.com',
    phoneVisible: false,
    joinedYear: 2022,
    isVerified: true,
  },
];
